<template lang="pug">
  .select-other
    b-form-group(
      :label="optionsLabel"
      :label-for="optionsFieldLabel"
    )
      b-form-select(
        :id="optionsFieldLabel"
        v-model="optionValue"
        :options="options"
        :disabled="readonly"
        @change="changed"
      )

    b-form-group(
      v-if="otherEnabled"
      :label="otherLabel"
      label-for="otherFieldLabel"
    )
      b-form-input(
        :id="otherFieldLabel"
        type="text"
        v-model="otherValue"
        :disabled="readonly"
        @change="changed"
      )
</template>

<script>
export default {
  name: 'select-other',
  data: () => ({
    optionValue: null,
    otherValue: null
  }),
  props: {
    value: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    otherEnabledValue: {
      type: String,
      required: true
    },
    optionsLabel: {
      type: String,
      required: true
    },
    optionsFieldLabel: {
      type: String,
      required: true
    },
    otherLabel: {
      type: String,
      required: true
    },
    otherFieldLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    otherEnabled() {
      return this.optionValue === this.otherEnabledValue
    }
  },
  methods: {
    changed() {
      this.$nextTick(() => {
        if (this.otherEnabled) {
          this.$emit('input', this.otherValue)

          return
        }

        this.$emit('input', this.optionValue)
      })
    }
  },
  beforeMount() {
    const selectedOption = this.options.find((o) => o.value === this.value)

    if (typeof selectedOption === 'undefined') {
      this.optionValue = this.otherEnabledValue
      this.otherValue = this.value
    } else {
      this.optionValue = this.value
    }
  }
}
</script>
